// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gVTps","left":"styles_left__16R2s","desktopActions":"styles_desktopActions__1zMPA","title":"styles_title__1P1Rt"};